import { render } from "./DropdownMenuItem.vue?vue&type=template&id=408e28fc"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=js"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=js"
script.render = render

export default script